import { Component, OnInit, Input } from '@angular/core';
import { Ephemeride } from 'app/models/ephemeride';
import { Patients } from 'app/models';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { PatientService } from 'app/core/patient.service';

@Component({
  selector: 'app-ajout-ephe',
  templateUrl: './ajout-ephe.component.html',
  styleUrls: ['./ajout-ephe.component.css']
})
export class AjoutEpheComponent implements OnInit {
 public ephemerides: Ephemeride[]; 
 public patient : Patients[];
 fb:FormBuilder;
  epheform: FormGroup;
  info: any;
  @Input()
  ephemeride:Ephemeride;
  public page = {
    limit: 15,
    count: 0,
    offset: 0,
    orderBy: "id",
    orderDir: "DESC"
  };
  constructor(
    private patientService: PatientService
  ) { }

  ngOnInit() {
    this.initEphemerideForms();
  this.loadPatient();
  }


  public initEphemerideForms() {
    this.epheform = this.fb.group({
      titre: [null, Validators.required],
      description: [null, Validators.required],
      type: [null, Validators.required],
      patient: [null, Validators.required]
    });
  }


  loadPatient(){
    const params = {
      sortName: `${this.page.orderBy}`,
      sortType: `${this.page.orderDir}`,
      page: `${this.page.offset}`,
      size: `${this.page.limit}`
    };
    this.patientService.find(params).subscribe(
      res => {
        this.patient = res.body;
        this.page.count = +res.headers.get("total");
      },
      error => {
        console.error(error);
      }
    );
  
  
    
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/layouts/admin/ajout-ephe/ajout-ephe.component.ts